import {connect} from 'react-redux';
import CartFooter from 'shared/CartFooter.jsx';
import {  checkout  } from './actions';
import {getCountInCart} from '../../shared/util/getCountInCart';

const mapStateToProps = state => ({
  total: state.registration.scheduler.total,
  countInCart: getCountInCart({
    virtualEvents: state.registration.scheduler.virtualEvents,
    events: state.registration.scheduler.events
  }),
  visible: !state.registration.scheduler.noDatesAvailable || !!state.registration.scheduler.allEvent.id
});

const mapDispatchToProps = dispatch => ({
  onReviewClick: () => dispatch(checkout())
});

export default connect(mapStateToProps, mapDispatchToProps)(CartFooter);



// WEBPACK FOOTER //
// ./src/features/registration/scheduler/CartFooterContainer.jsx